import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TermsAndConditionService } from '../services/terms-and-condition.service';
import { TitleService } from '../services/title.service';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../services/loader.service';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import liff from '@line/liff';
declare var window: any;

@Component({
    selector: 'app-skymazda',
    templateUrl: './skymazda.component.html',
    styleUrls: ['./skymazda.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SkymazdaComponent implements OnInit {

  liffId: string;
  lineId: string;
  profile: any
  loader: Observable<boolean>;

  constructor(
    private termsAndConditionService: TermsAndConditionService,
    private titleService: TitleService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
  ) { }

  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(params)
      if (params['session_ref']) {
        liff.closeWindow();
      }
    })
    this.loader = this.loaderService.loadingObservable;
    this.loaderService.opendLoader();
    this.titleService.setTitle('SKY JOURNEY');
    this.liffId = '1653929731-MO0lQNKe';
    await liff.init({ liffId: this.liffId })
    if (liff.isLoggedIn() == false && liff.isInClient() == false) {
      liff.login({ redirectUri: window.location.href });
    }
    else {
      this.openTermsAndCondition();
    }
    try {
      this.profile = await liff.getProfile();
      this.lineId = this.profile.userId;
    }
    catch (e) {
      this.lineId = 'U92fc26c257f888f5aa4a6ce1690c16c1'
      console.log(e);
    };
    console.log(this.profile);
    if (environment.log_level == 'debug') {
      window.vConsole = new window.VConsole();
    }
  }

  async openTermsAndCondition() {
    console.log('term & condition')
    const session_ref = new Date().valueOf()
    let requestBody = {
      electronic_channel: 2,
      channel_identity: '',// getProfile
      liff_url: window.location.href,// post back //เปลี่ยนให้มันคอล skymazda แทน
      session_ref: session_ref
    }
    this.termsAndConditionService.apiCheckTermsAndCondition(requestBody).subscribe(
      result => {
        this.loaderService.closeLoader();
        if (result && result.response_code == "40000") {
          if (result.payload.token_url) {
            window.location.href = result.payload.token_url;
          }
        }
        console.log(result)
      },
      error => {

      }
    );
  }
}
